import {
  Badge,
  BADGE_COLOR_VARIANTS,
} from '@bambi/component-library/src/components/Badge/Badge';

import { TripEventRead } from 'src/common/external/bambi-api/bambiApi';

import { eventTypeColorMapToBadgeColorVariant } from './eventTypeColorMap';
import { TripSummaryDefaultTextDisplay } from './TripSummaryDefaultTextDisplay';
import { TripSummaryFormattedPickupTime } from './TripSummaryFormattedPickupTime';

export function TripSummaryAdditionalInfo({
  tripEvent,
}: {
  tripEvent: TripEventRead;
}) {
  const tripStatusBadgeDisplayMap = {
    status_at_dropoff: 'at dropoff',
    status_at_pickup: 'at pickup',
    status_en_route: 'en route',
    status_transporting: 'transporting',
  };

  const badgeColor =
    eventTypeColorMapToBadgeColorVariant[
      tripEvent.event_type as keyof typeof eventTypeColorMapToBadgeColorVariant
    ];

  const tripStatusBadgeDisplay =
    tripStatusBadgeDisplayMap[
      tripEvent.event_type as keyof typeof tripStatusBadgeDisplayMap
    ];

  if (tripEvent.event_type === 'assign') {
    return <TripSummaryDefaultTextDisplay text={`to ${tripEvent.driver}`} />;
  }

  if (tripStatusBadgeDisplay) {
    return (
      <Badge
        color={badgeColor || BADGE_COLOR_VARIANTS.PRIMARY}
        label={tripStatusBadgeDisplay}
      />
    );
  }

  if (tripEvent.event_type === 'update_pickup_at') {
    return <TripSummaryFormattedPickupTime tripEvent={tripEvent} />;
  }

  return <div>&nbsp;</div>;
}
